'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$002dSign$002dDocument$002dError$002dContext from "./presto.-Danger-Alert$-Sign-Document-Error-Context.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$002dUnified$002dError$002dContext from "./presto.-Danger-Alert$-Unified-Error-Context.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$14() {
}
export { $c_Lpresto_DangerAlert$$anon$14 as $c_Lpresto_DangerAlert$$anon$14 };
$p = $c_Lpresto_DangerAlert$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$14;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$14() {
}
export { $h_Lpresto_DangerAlert$$anon$14 as $h_Lpresto_DangerAlert$$anon$14 };
$h_Lpresto_DangerAlert$$anon$14.prototype = $p;
$p.cM2 = (function(x$0) {
  if ((x$0 instanceof $j_presto$002e$002dDanger$002dAlert$0024$002dSign$002dDocument$002dError$002dContext.$c_Lpresto_DangerAlert$SignDocumentErrorContext)) {
    return 0;
  }
  if ((x$0 instanceof $j_presto$002e$002dDanger$002dAlert$0024$002dUnified$002dError$002dContext.$c_Lpresto_DangerAlert$UnifiedErrorContext)) {
    return 1;
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$0);
});
var $d_Lpresto_DangerAlert$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$14, "presto.DangerAlert$$anon$14", ({
  GM: 1,
  a: 1,
  e: 1,
  H: 1
}));
export { $d_Lpresto_DangerAlert$$anon$14 as $d_Lpresto_DangerAlert$$anon$14 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$14.js.map
